import { render, staticRenderFns } from "./resetPasswordDialog.vue?vue&type=template&id=5cfe5d22&lang=pug&"
import script from "./resetPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./resetPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports